<template>
  <div class="certificates-list-view">
    <title-component :size="1">
      <translate>Certificates list</translate>
    </title-component>
    <table-component-buefy
      v-if="mixin.loaded"
      :content="certificates"
      :headings="headings"
      :item_keys="item_keys"
      :display_spec="certificateSpecs"
      :total_items="mixin.total_items"
      :pagination_callback="mixin.loadItems"
      class="veridens-dashboard">
    </table-component-buefy>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'
  import { certificateSpecs } from '@/display_context/display_context'
  import { loadItemsMixin, setContainedHeightMixin } from '@/mixins/mixins'

  export default {
    name: 'certificate-list-view',
    mixins: [loadItemsMixin, setContainedHeightMixin],
    data () {
      return {
        headings: ['Certificate No.', 'Certification', 'Qualification', 'State', 'Issued date', 'Expiry date '],
        item_keys: ['certificateLink', 'service.shortName', 'qualification.value', 'state', 'issueDate', 'expiryDate'],
        certificateSpecs: certificateSpecs,
        mixin: { actionMethod: this.getCertificates }
      }
    },
    components: {
      TitleComponent,
      TableComponentBuefy
    },
    computed: {
      ...mapState({
        certificates: state => state.certificateModule.certificates
      })
    },
    methods: {
      ...mapActions([
        'getCertificates'
      ])
    }
  }
</script>
